import { ApolloCache } from "@apollo/client"

import { evict } from "shared/api/evict"
import { SpecialPriceGroupTypename } from "shared/types/Project"

export function evictSpecialPriceGroup(id: string, cache: ApolloCache<object>) {
  evict({
    cache,
    id,
    typename: SpecialPriceGroupTypename
  })
}
